import React from 'react';
import { MessageSquare } from 'lucide-react';
import ChatWidget from './ChatWidget';
import { useI18n } from '../i18n/i18n';

const ChatLauncher: React.FC = () => {
  const { t } = useI18n();
  
  return (
    <div className="w-full h-full bg-white">
      {/* Header */}
      <div className="flex items-center px-4 py-3 border-b border-gray-200 bg-white/90 backdrop-blur">
        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
            <MessageSquare className="h-4 w-4 text-primary-600" />
          </div>
          <h2 className="text-sm font-semibold text-gray-900">{t('chat.assistant')}</h2>
        </div>
      </div>

      {/* Body */}
      <div className="h-[calc(100%-60px)] overflow-hidden">
        <div className="h-full p-4">
          <div className="h-full">
            <ChatWidget />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatLauncher;
